import $ from 'jquery'
import Blazy from 'blazy'
// import { initImage as initGlitchImage } from './image-glitch'

// transparent gif,
export const placeholderImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
const effectSpeed = 300 // ms

export function init() {
  loadMedia()
}

export function lazyloadNewMedia() {
  loadMedia()
}

export function loadMedia(selector = '.lazy') {
  new Blazy({
    selector,
    successClass: ' ',
    errorClass: 'error',
    success: (elem) => {
      const $elem = $(elem)
      $elem.parent().addClass('no-spinner')
      setTimeout(() => $elem.addClass('loaded'), 10)
      setTimeout(() => {
        if ($elem.parent().hasClass('media')) $elem.parent().addClass('ignore-static')
        // initGlitchImage($elem);
      }, effectSpeed + 5)
    },
  })
}
